import React, {useEffect, useState} from "react";
import {CommonData} from "../PageImports.ts";
import {
    SubHeaderTitle,
    Tabination,
} from "../../components/common";
import {Helmet} from "react-helmet";
import CampaignTab from "../../components/VLoyalty/CampaignTab.tsx";
import PointSetupTab from "../../components/VLoyalty/PointSetupTab.tsx";
import ErrorPage from "../Error/ErrorPage.tsx";
import Loader from "../../utils/Loader.tsx";
import useVLoyaltyRelatedApi from "../../hooks/VLoyalty/useVLoyaltyRelatedApi.ts";
import { ErrorState } from "../Contact/MainDataTable.tsx";
 
 

const {Wrapper, WrapperSubHeader, WrapperContent, WrapperCard, Row} = CommonData;

interface VLoyaltyProps {
    navUrl: string;
}

const VLoyalty: React.FC<VLoyaltyProps> = ({navUrl}) => {

    const {loyaltyPermissions, loadingData, permissionError} = useVLoyaltyRelatedApi();

    const [tabView, setTabView] = useState<string>("campaign");
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<ErrorState | null>(null);
    const [contactTabsView, setContactTabsView] = useState<{
        label: string;
        value: string;
        index: number;
        child: JSX.Element;
        show: boolean
    }[]>([]);

    const handleTabChange = (_event: any, newValue: string) => {
        setTabView(newValue);
    };

    useEffect(() => {
        if (loyaltyPermissions) {
            if (loyaltyPermissions.vLoyalty.isView === 0) {
                setError({
                    code: "200",
                    message: "You don't have permission to view this page",
                });
                setIsLoading(false);
                return;
            }

            const filteredTabs = [
                {
                    label: "Campaign",
                    value: "campaign",
                    index: 0,
                    child: <CampaignTab permissions={loyaltyPermissions.campaign}/>,
                    show: loyaltyPermissions?.campaign?.isView === 1
                },
                {
                    label: "Point Setup",
                    value: "pointSetup",
                    index: 1,
                    child: <PointSetupTab permissions={loyaltyPermissions.campaign}/>,
                    show: loyaltyPermissions?.pointSetup?.isView === 1
                },
            ].filter(tab => tab.show);

            setContactTabsView(filteredTabs);
            setTabView(filteredTabs.length > 0 ? filteredTabs[0]?.value ?? "" : "");
            setIsLoading(false);
        }
    }, [loyaltyPermissions]);

    if (error) {
        return <ErrorPage error={error}/>;
    }
    if (permissionError) {
        return <ErrorPage error={permissionError}/>;
    }

    if (isLoading || loadingData) {
        return <Loader/>;
    }

    if (contactTabsView.length === 0) {
        return <ErrorPage error={{code: "200", message: "You don't have permission to view this page"}}/>;
    }

    return (
        <>
            <Helmet>
                <title>{navUrl}</title>
            </Helmet>
            <Wrapper navUrl={navUrl} customStyle={{height: "750px"}}>
                <WrapperSubHeader>
                    <div className="mr-auto">
                        <SubHeaderTitle subTitle={tabView.charAt(0).toUpperCase() + tabView.slice(1)}/>
                    </div>
                </WrapperSubHeader>
                <WrapperContent>
                    <Row>
                        <WrapperCard>
                            <Tabination
                                tabs={contactTabsView}
                                handleTabChange={handleTabChange}
                                tabView={tabView}
                            />
                            {contactTabsView.length > 0 && (
                                <>
                                    {contactTabsView.find(tab => tab.value === tabView)?.child || <p>No content</p>}
                                </>
                            )}
                        </WrapperCard>
                    </Row>
                </WrapperContent>
            </Wrapper>
        </>
    );
};

export default VLoyalty;
